import { post } from '@/api/http.js';

const exportFile = (url, query, fileName = 'file') => {
    query['is_download'] = '1';
    post(url, query, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded' //请求的数据类型为form data格式
        },
        responseType: 'blob' // 设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
    }).then(function(res) {
        res = "\uFEFF" + res;
        let blob = new Blob([res], {
            type: 'application/vnd.ms-excel,charset=utf-8'
        });
        let url = window.URL.createObjectURL(blob); //创建下载链接
        let link = document.createElement('a');
        link.download = fileName + '.csv'; //下载后的文件名
        link.href = url;
        link.click();
    });
}
const excelFile = (url, query, fileName = 'file') => {
    query['is_download'] = '1';
    post(url, query, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded' //请求的数据类型为form data格式
        },
        responseType: 'blob' // 设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
    
    }).then(function(res) {
        res = "\uFEFF" + res;
        // 获取headers中的filename文件名
        let tempName = res.headers['content-disposition'].split(';')[1].split('filename=')[1]
        // iconv-lite解决中文乱码
        let iconv = require('iconv-lite')
        iconv.skipDecodeWarning = true// 忽略警告
        let fileName = iconv.decode(tempName, 'gbk')
        let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel,charset=utf-8'
        });
        let url = window.URL.createObjectURL(blob); //创建下载链接
        let link = document.createElement('a');
        link.download = fileName + '.xlsx'; //下载后的文件名
        link.href = url;
        link.click();
    });
}

export default {
  exportFile: exportFile,
  excelFile:excelFile
}